import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2164447088/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/brands/[id]/content.tsx");
